module.exports = require("@hsq/media-breakpoints");